import logic from "src/utils/genLogic";
import actions, { ActionTypes } from "./actions";
import { push } from "connected-react-router";
import { Trans } from "@lingui/react";
const apiNamespace = "ProductSkus";

const getProductSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_PRODUCT_SKU,
});

const getAllProductSkusLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_PRODUCT_SKUS,
});

const createProductSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.CREATE_PRODUCT_SKU,
  successCb: (dispatch) => {
    dispatch(push("/productSkus/list"));
  },
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_added_successfully" />,
});
const editProductSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_PRODUCT_SKU,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_edited_successfully" />,
});
const deleteProductSkuLogic = logic(apiNamespace, {
  actionName: ActionTypes.DELETE_PRODUCT_SKU,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_deleted_successfully" />,
});

export default [
  getProductSkuLogic,
  getAllProductSkusLogic,
  createProductSkuLogic,
  editProductSkuLogic,
  deleteProductSkuLogic,
];
